import React from 'react';
import { DOSSIER_STATUSES_LABELS } from '../../constants/dossierStatuses';
import { TRANSACTION_STATUSES_LABELS } from '../../constants/transactionStatuses';

const FLOW_STATUSES_LABELS = {
  PLANNED: "Planifié",
  INITIATED: "Initié",
  PROCESSING: "En traitement",
  SETTLED: "Réglé",
  RECONCILED: "Rapproché",
  FAILED: "Échoué",
  CANCELLED: "Annulé",
  COMPLETED: "Traité",
  PENDING: "En attente"
};

export default function StatusBadge({ status, type = 'dossier' }) {
  let label;
  if (type === 'dossier') {
    label = DOSSIER_STATUSES_LABELS[status];
  } else if (type === 'flow') {
    label = FLOW_STATUSES_LABELS[status] || status;
  } else {
    label = TRANSACTION_STATUSES_LABELS[status];
  }

  if (!label) return <span className="badge badge-neutral">{status}</span>;

  const isPositive = ['APPROVED', 'COMPLETED', 'FUNDED', 'ACTIVE', 'READY_TO_FUND', 'SETTLED', 'RECONCILED'].includes(status);
  const isWarning = ['ON_HOLD', 'APPROVED_WITH_CONDITIONS', 'DOCUMENTS_PENDING', 'WAITING_SIGNATURE', 'PENDING', 'PLANNED', 'PROCESSING'].includes(status);
  const isNegative = ['REJECTED', 'CANCELLED', 'DEFAULTED', 'FAILED'].includes(status);
  
  let colorClass = 'badge-info'; 
  if (isPositive) colorClass = 'badge-success';
  if (isWarning) colorClass = 'badge-warning';
  if (isNegative) colorClass = 'badge-danger';
  if (status === 'STRUCTURING') colorClass = 'badge-primary';

  return (
    <span className={`badge ${colorClass}`}>
      {label}
    </span>
  );
}
